export function compareIdentifiers(a: number | string, b: number | string): number {
  if (typeof a === 'number' && typeof b === 'number') {
    return a === b ? 0 : a < b ? -1 : 1;
  }

  const anum = /^[0-9]+$/.test(a as string);
  const bnum = /^[0-9]+$/.test(b as string);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
